<div class="At-Sidebar At-SidebarComment At-CustomScroll">
    <div class="At-SidebarShareTop">
        <div class="At-CloseSidebar" (click)="close()"> <i class="icon-cancel"></i></div>
        <div class="At-SidebarShareTopInner">
            <div class="At-InfoBox">
                <div class="At-InfoImg">
                    <figure class="At-FigureW55">
                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                        <div class="At-badgePurple"><i class="icon-bage"></i></div>
                    </figure>
                </div>
                <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                        <h5>Julian • <span class="At-TextRedLight">jona</span> • <span
                                class="At-TextRedLight">COO</span> </h5>
                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                        <p class="mt-3">Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor
                            incididunt ...</p>
                    </div>
                </div>
            </div>
            <!-- At-InfoBox ends  -->

        </div>
    </div>
    <!-- At-SidebarShareTop ends  -->
    <div class="At-SidebarShareMiddle">
        <div class="At-SidebarShareMiddleInner">

            <div class="At-SidebarShareBtns">
                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small4.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Nathaniel.DS: <span class="At-TextDarkGrey2">Bring me a hoodie from there
                                    will ya</span></h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->

                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                    class="icon-like At-TextRed"></i> </h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->

                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small4.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Nathaniel.DS: <span class="At-TextDarkGrey2">Bring me a hoodie from there
                                    will ya</span></h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->

                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                    class="icon-like At-TextRed"></i> </h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->

                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small4.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Nathaniel.DS: <span class="At-TextDarkGrey2">Bring me a hoodie from there
                                    will ya</span></h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->

                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                    class="icon-like At-TextRed"></i> </h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->

                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                    class="icon-like At-TextRed"></i> </h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->

                <div class="At-InfoBox">
                    <div class="At-InfoImg">
                        <figure class="At-FigureW55">
                            <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                        </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                        <div class="At-TitleLeft">
                            <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span>
                            </h5>
                            <ul class="At-LikesUl">
                                <li>2m ago</li>
                                <li>22 Likes</li>
                                <li>REPLY</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- At-InfoBox ends  -->
            </div>
        </div>
    </div>
    <!-- At-SidebarShareMiddle ends  -->
    <div class="At-SidebarShareBottom">
        <div class="At-SidebarShareBottomInner">
            <div class="form-group mb-0 At-FormWithIcon">
                <i class="icon-send-1 At-CursorPointer"></i>
                <i class="icon-face-emoji iconTwo"></i>
                <input class="form-control At-InputSearch" type="text" placeholder="Say something ...">
            </div>
        </div>
    </div>
    <!-- At-SidebarShareBottomInner ends  -->
</div>
